<div #customAddedToCartDialog
  id="addToCartDialog"
  class="custom-added-to-cart-dialog"
  (mouseover)="stopTimer()"
  (mouseleave)="startTimer()"
  >
  <!-- Modal Header -->
  <div class="cx-dialog-header modal-header">
    <div class="cx-dialog-title modal-title">
      @if ((addedEntryWasMerged$ | async)) {
        <div>
          {{ 'addToCart.itemsIncrementedInYourCart' | cxTranslate}}
        </div>
        <div>
          {{ 'addToCart.itemsUpdatedInYourCart' | cxTranslate}}
        </div>
      } @else {
        <div>
          {{ 'addToCart.itemsAddedToYourCart' | cxTranslate}}
        </div>
      }
    </div>
    <button type="button" class="close-modal-cart" aria-label="Close" (click)="dismissModal('Cross click')">
      <span aria-hidden="true">
        <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
      </span>
    </button>
  </div>
  <!-- Modal Body -->
  @if ((displayEntry$ | async); as entry) {
    <div class="cx-dialog-body modal-body">
      <div class="cx-dialog-row">
        <div class="cx-dialog-item">
          <cx-cart-item [item]="entry" [compact]="true" [quantityControl]="getQuantityControl()|async"
            [promotionLocation]="promotionLocation">
          </cx-cart-item>
        </div>
        <!-- Total container -->
        <div class="cx-dialog-actions" >
          @if (orderPromotions$ | async; as orderPromotions) {
            <!-- Promotions -->
            @if (orderPromotions.length > 0) {
              <div class="cx-dialog-promotions">
                <cx-promotions [promotions]="orderPromotions"></cx-promotions>
              </div>
            }
          }
          <!-- Free delivery promo -->
          @if (cart$ | async; as cart) {
            @if (cart.possibleFreeDelivery) {
              <div class="free-shipment-container-minicart">
                @if (remainingAmountForFreeDelivery(cart) > 0) {
                  <p
                    [innerHTML]="'orderCost.remainingFreeShippingDialog' | cxTranslate: { totalValue: cartSubtotalRounded(cart) ,remainingAmount:  remainingAmountForFreeDeliveryWithCommas(cart) }">
                  </p>
                } @else {
                  <p [innerHTML]="'orderCost.freeShippingCart' | cxTranslate"></p>
                }
              </div>
            }
          }
          <!-- Actions -->
          <div class="cx-dialog-buttons">
            <a [class.disabled]="form.dirty" (click)="closeModal()" cxModal="dismiss"
              cxModalReason="Proceed To Checkout click" class="btn-mini-cart btn-white">
              {{ 'addToCart.proceedToCheckout' | cxTranslate }}
            </a>
            <a [class.disabled]="form.dirty" (click)="goToCart()" cxModal="dismiss"
              cxModalReason="View Cart click" class="btn-mini-cart btn-black" autofocus>
              {{ 'addToCart.viewCart' | cxTranslate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  }
</div>